import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  CustomInput,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
} from "reactstrap";
import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  AddCommaNumber,
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
  RandomString,
  getDateWithFormat,
  getAvatar,
  getCurrentDate,
} from "../../../helpers/Utils";
import createSocket from "../../../helpers/createSocket";
import { Pagination } from "../../../containers/pages/general";
import LogsHelper from "../../../helpers/Logs";
import IntlMessages from "../../../helpers/IntlMessages";
import {
  GetSalaryBy,
  GetStatusWorking,
  GetWorkingHours,
  WorkingHours,
  FindUpdateForm,
} from "../../../helpers/UserStaff";
import classnames from "classnames";
import { isC, isR, isU, isD } from "../../../helpers/Roles";
import { NavLink } from "react-router-dom";
import FooterPage from "../../../containers/pages/FooterPage";
import FooterUserStaff from "../../../containers/pages/user-staff/FooterUserStaff";
import AddUserStaff from "../../../containers/pages/user-staff/AddUserStaff";
import AddUserStaffLog from "../../../containers/pages/user-staff/AddUserStaffLog";
import UpdateUserStaff from "../../../containers/pages/user-staff/UpdateUserStaff";
import { connect } from "react-redux";
import { setSearchContext } from "../../../redux/actions";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import moment from "moment";
import { injectIntl } from "react-intl";

const DEFAULT_FORM = {
  id: "",
  name: "",
  phone: "",
  email: "",
  address: "",
  permission_name: "",
  date_join: new Date(),
  date_get_salary: "1",
  salary_by: "h",
  salary_value: "",
  working_hours: [],
  hour_working_on_day: 8,
  status_working: "on",

  // disabled
  total_salary: "",
  total_day_working: "",
  current_salary: "",
  current_day_working: "",
  current_commission: "",
  current_bonus: "",
  current_overtime: "",
  current_advence: "",
  current_fined: "",
  current_dayoff: "",
  pending_date: null,
  pending_hour: null,
  lst_6_month: [],

  // logs
  logs_users_staff: "",
  logs_type: "commission",
  logs_value: "",
  logs_value_overtime_coefficient: 1,

  dynamic_form: [],
};

const ROLE_ALIAS = "user_staff";
const DETAIL_TABS = [
  { id: "info", label: "user-staff.detail.tab.info" },
  { id: "schedule", label: "user-staff.detail.tab.schedule" },
  { id: "performance", label: "user-staff.detail.tab.performance" },
  { id: "salary", label: "user-staff.detail.tab.salary" },
  { id: "permission", label: "user-staff.detail.tab.permission" },
];

const getInitials = (name) => {
  const words = `${name || ""}`.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "NV";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
};

const getMoney = (value) => `${AddCommaNumber(value || 0)}đ`;

const getPositionClass = (position = "") => {
  const normalized = position.toLocaleLowerCase("vi-VN");
  if (normalized.includes("quản")) return "staff-redesign__badge--purple";
  if (normalized.includes("thu")) return "staff-redesign__badge--blue";
  if (normalized.includes("phục")) return "staff-redesign__badge--green";
  if (normalized.includes("pha")) return "staff-redesign__badge--orange";
  if (normalized.includes("bếp")) return "staff-redesign__badge--red";
  if (normalized.includes("kho")) return "staff-redesign__badge--cyan";
  return "staff-redesign__badge--yellow";
};

const formatWorkingHours = (workingHours) => {
  if (!workingHours || !workingHours.length) return "--";
  return workingHours.map((time) => `${time.start} - ${time.end}`).join(", ");
};

const getShiftName = (workingHours) => {
  if (!workingHours || !workingHours.length) return "--";

  const start = workingHours[0].start || "";
  const hour = parseInt(start.split(":")[0], 10);

  if (Number.isNaN(hour)) return "--";
  if (hour < 12) return "Ca sáng";
  if (hour < 18) return "Ca chiều";
  if (hour < 24) return "Ca tối";
  return "Hành chính";
};

const findAnalytics = (analyticsByStaffId, id) =>
  analyticsByStaffId && analyticsByStaffId[id]
    ? analyticsByStaffId[id]
    : {
        total_sales: 0,
        bill_count: 0,
        product_count: 0,
        revenue_per_hour: 0,
        commission: 0,
        bonus: 0,
        ranking: null,
      };

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      selectedItems: [],
      data: [],
      data_all: [],
      license: {},
      data_length: 0,
      data_length: 0,
      hide_button_add: false,
      staffLimit: Infinity,
      totalStaff: 0,
      filter: null,
      filters: {
        position: "",
        status: "",
        shift: "",
      },
      selectedStaffId: null,
      staffDetailsById: {},
      analyticsByStaffId: {},
      analyticsAllTimeByStaffId: {},
      analyticsSummary: {},
      analyticsAllTimeSummary: {},
      data_dynamic_form: [],
      data_detail: {},
      is_loading_data: true,
      is_loading_data_detail: true,
      is_loading_analytics: false,
      isDetailModalOpen: false,
      show: {
        add: false,
        update: false,
        view: false,
        log: false,
        viewonly: true,
      },
      accordion: [],
      activeTab: "1",
      detailPanelTab: "info",
      form: DEFAULT_FORM,
    };

    this.detailTabsRef = React.createRef();
    this.isDetailTabsDragging = false;
    this.detailTabsDragStartX = 0;
    this.detailTabsScrollStartX = 0;
    this.detailTabsWasDragged = false;
    this.socket = createSocket();
  }

  isMobileStaffView = () =>
    typeof window !== "undefined" && window.innerWidth < 992;

  closeDetailModal = () => {
    this.setState({ isDetailModalOpen: false });
  };

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar
    this.props.setSearchContext("staff");

    this.dataListRender();
    this.dataStaffAnalyticsRender();
    this.getLicense();

    window.addEventListener("refresh-user-staff-list", this.handleRefreshEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("refresh-user-staff-list", this.handleRefreshEvent);
  }

  handleRefreshEvent = () => {
    this.dataListRender();
    this.dataStaffAnalyticsRender();
    this.getLicense();
  };

  componentDidUpdate(prevProps) {
    // Listen thay đổi searchKeyword từ Redux (Navbar search)
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: this.props.searchKeyword,
          },
        }),
        () => this.dataListRender()
      );
    }
  }

  onDetailTabsMouseDown = (event) => {
    const tabs = this.detailTabsRef.current;
    if (!tabs || event.button !== 0) return;

    this.isDetailTabsDragging = true;
    this.detailTabsWasDragged = false;
    this.detailTabsDragStartX = event.pageX;
    this.detailTabsScrollStartX = tabs.scrollLeft;
    tabs.classList.add("is-grabbing");
  };

  onDetailTabsMouseMove = (event) => {
    const tabs = this.detailTabsRef.current;
    if (!tabs || !this.isDetailTabsDragging) return;

    const distance = event.pageX - this.detailTabsDragStartX;
    if (Math.abs(distance) > 4) {
      this.detailTabsWasDragged = true;
    }

    tabs.scrollLeft = this.detailTabsScrollStartX - distance;
  };

  onDetailTabsMouseUp = () => {
    const tabs = this.detailTabsRef.current;
    this.isDetailTabsDragging = false;
    if (tabs) tabs.classList.remove("is-grabbing");

    window.setTimeout(() => {
      this.detailTabsWasDragged = false;
    }, 0);
  };

  onDetailTabClick = (event, tab) => {
    if (this.detailTabsWasDragged) {
      event.preventDefault();
      return;
    }

    this.toggleDetailTab(tab);
  };

  getLicense = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/user-license"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        console.log("data: ", res.data);
        return res.data;
      })
      .then((data) => {
        let user_license = data.data;

        let currentDate = getCurrentDate();
        if (user_license.expired_date < currentDate && !user_license.upgraded) {
          this.setState((prev) => ({
            license: {
              using: false,
            },
          }));
        }

        this.hideButtonAdd();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  };

  hideButtonAdd = () => {
    let { staffLimit, totalStaff } = this.state;
    // Fix: infinity converts to null in JSON, so we check using Number.isFinite
    if (Number.isFinite(staffLimit) && totalStaff >= staffLimit) {
      this.setState({
        hide_button_add: true,
      });
    } else {
      this.setState({
        hide_button_add: false,
      });
    }
  };

  /** Axios func helper */
  dataListRender = () => {
    const { selectedPageSize, currentPage, search } = this.state.page;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${
          END_POINT + "/user-staff/json"
        }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      )
      .then((res) => res.data)
      .then((data) => {
        const listData = data.data || [];
        let anyAccordion = [];
        let numeroPerguntas = listData.length;
        for (var i = 0; i < numeroPerguntas; i++) {
          // if (!i) {
          //     anyAccordion.push(true);
          // }
          anyAccordion.push(false);
        }
        const keepSelectedId =
          this.state.selectedStaffId &&
          listData.some((item) => item.id === this.state.selectedStaffId);
        const nextSelectedItem = keepSelectedId
          ? listData.find((item) => item.id === this.state.selectedStaffId)
          : listData[0];
        const nextSelectedId = nextSelectedItem ? nextSelectedItem.id : null;

        this.setState(
          (prev) => ({
            ...prev,
            data: listData,
            data_all: listData,
            data_length: listData.length,
            data_dynamic_form: data.dataDynamicForm,
            is_loading_data: false,
            is_loading_data_detail: Boolean(nextSelectedId),
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
            accordion: anyAccordion,
            staffLimit: data.staffLimit,
            totalStaff: data.totalStaff,
            selectedStaffId: nextSelectedId,
            selectedItems: [],
            show: {
              ...prev.show,
              update: false,
              view: Boolean(nextSelectedId),
              viewonly: !nextSelectedId,
            },
            form: nextSelectedId
              ? {
                  ...prev.form,
                  id: nextSelectedId,
                  dynamic_form: nextSelectedItem.dynamic_form,
                }
              : DEFAULT_FORM,
          }),
          () => {
            this.hideButtonAdd();
            if (nextSelectedId) this.dataUserStaffRender(nextSelectedId);
          }
        );
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText);
        return false;
      });
  };

  dataStaffAnalyticsRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    const today = moment().format("YYYY-MM-DD");

    this.setState({ is_loading_analytics: true });

    const requestConfig = { headers: { Authorization: `Bearer ${tokenStr}` } };
    const emptyAnalyticsResponse = { data: { data: { summary: {}, data: [] } } };

    axios
      .all([
        axios.get(
          `${END_POINT}/analytics/staff?all=false&compare=false&date_start=${today}&date_end=${today}&company_uuid=null`,
          requestConfig
        ).catch(() => emptyAnalyticsResponse),
        axios.get(
          `${END_POINT}/analytics/staff?all=true&compare=false&date_start=${today}&date_end=${today}&company_uuid=null`,
          requestConfig
        ).catch(() => emptyAnalyticsResponse),
      ])
      .then(
        axios.spread((todayRes, allTimeRes) => {
          const payload = todayRes.data?.data || {};
          const allTimePayload = allTimeRes.data?.data || {};
          const analyticsByStaffId = {};
          (payload.data || []).forEach((item) => {
            analyticsByStaffId[item.id] = item;
          });
          const analyticsAllTimeByStaffId = {};
          (allTimePayload.data || []).forEach((item) => {
            analyticsAllTimeByStaffId[item.id] = item;
          });

          this.setState({
            analyticsByStaffId,
            analyticsAllTimeByStaffId,
            analyticsSummary: payload.summary || {},
            analyticsAllTimeSummary: allTimePayload.summary || {},
            is_loading_analytics: false,
          });
        })
      )
      .catch(() => {
        this.setState({
          analyticsByStaffId: {},
          analyticsAllTimeByStaffId: {},
          analyticsSummary: {},
          analyticsAllTimeSummary: {},
          is_loading_analytics: false,
        });
      });
  };

  dataUserStaffRender = (id) => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/user-staff?user_staff_id=${id}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        console.log("Nhân viên: ", data.data);
        const detail = data.data || {};
        const workingHours = WorkingHours(detail.setting?.working_hours);
        this.setState((prev) => ({
          ...prev,
          is_loading_data_detail: false,
          selectedStaffId: id,
          data_detail: detail,
          staffDetailsById: {
            ...prev.staffDetailsById,
            [id]: detail,
          },
          form: {
            ...DEFAULT_FORM,
            dynamic_form: prev.form.dynamic_form, // Preserve dynamic_form from click event
            id: detail.id,
            email: detail.email,
            name: detail.name,
            phone: detail.phone,
            address: detail.address,
            birthday: detail.birthday,
            date_get_salary: detail.setting?.date_get_salary,
            date_join: detail.setting?.date_join,
            hour_working_on_day: detail.setting?.hour_working_on_day,
            permission_name: detail.setting?.permission_name,
            salary_by: detail.setting?.salary_by,
            salary_value: detail.setting?.salary_value,
            status_working: detail.setting?.status_working,
            working_hours: workingHours,

            // disabled
            current_commission: detail.current_commission,
            current_bonus: detail.current_bonus,
            current_overtime: detail.current_overtime,
            current_advence: detail.current_advence,
            current_fined: detail.current_fined,
            current_dayoff: detail.current_dayoff,
            current_day_working: detail.current_day_working,
            current_salary: detail.current_salary,
            total_day_working: detail.total_day_working,
            total_salary: detail.total_salary,
            pending_date: detail.pending_date,
            pending_hour: detail.pending_hour,
            lst_6_month: detail.lst_6_month,
            // Thêm số giờ raw từ server
            overtime_hour: detail.overtime_hour || 0,
            day_off_hour: detail.day_off_hour || 0,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onDownloadPdfUserStaffRender = ({ month, year }) => {
    let tokenStr = localStorage.getItem("access_token");
    this.setState(
      (prev) => ({
        ...prev,
        is_loading_data_detail: true,
      }),
      async () => {
        await axios
          .get(
            `${END_POINT}/user-staff?user_staff_id=${this.state.form.id}&month=${month}&year=${year}`,
            { headers: { Authorization: `Bearer ${tokenStr}` } }
          )
          .then((res) => res.data)
          .then((data) => {
            const link = data.data;

            if (link) {
              window.open(getAvatar(link), "_target");
            }
          })
          .catch((err) => {
            NotificatioErrController(err.response.data.responseText);
            return false;
          });

        this.setState((prev) => ({
          ...prev,
          is_loading_data_detail: false,
        }));
      }
    );
  };

  // dataAllRender = () => {
  //     let tokenStr = localStorage.getItem('access_token');
  //     axios
  //         .get(`${END_POINT + '/user-staff'}`, {
  //             headers: { Authorization: `Bearer ${tokenStr}` },
  //         })
  //         .then((res) => res.data)
  //         .then((data) => {
  //             this.setState((prev) => ({
  //                 ...prev,
  //                 data_all: data.data,
  //             }));
  //         })
  //         .catch((err) => {
  //             NotificatioErrController(err.response.data.responseText);
  //             return false;
  //         });
  // };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT + "/user-staff"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["user-staff-delete"],
        });

        this.dataListRender();
        this.dataStaffAnalyticsRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerUpdate = (e, salary_apply_date = null) => {
    if (!isU(ROLE_ALIAS)) return false;
    if (e && e.preventDefault) e.preventDefault();

    const {
      id,
      name,
      phone,
      email,
      address,
      permission_name,
      date_join,
      status_working,
      dynamic_form,
    } = this.state.form;

    if (!name || !id) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    // Cập nhật dữ liệu gửi lên
    const update_form = FindUpdateForm({
      _new: this.state.form,
      find_user_staff: this.state.data_detail,
    });

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/user-staff"}`,
        {
          id,
          name,
          phone,
          email,
          address,
          permission_name,
          status_working,
          date_join: getDateWithFormat(date_join),

          date_get_salary: update_form.date_get_salary,
          salary_by: update_form.salary_by,
          salary_value: update_form.salary_value,

          hour_working_on_day: update_form.hour_working_on_day,
          working_hours: update_form.working_hours,
          dynamic_form,

          // New: salary apply date from DatePicker
          salary_apply_date: salary_apply_date,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["user-staff-update"],
        });

        this.dataListRender();
        this.dataStaffAnalyticsRender();
        this.toggle("update");
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerAdd = (e) => {
    if (!isC(ROLE_ALIAS)) return false;

    e.preventDefault();

    const {
      name,
      phone,
      email,
      address,
      permission_name,
      date_join,
      date_get_salary,
      salary_by,
      salary_value,
      working_hours,
      hour_working_on_day,
      status_working,
      dynamic_form,
    } = this.state.form;

    if (!name) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    let _salary_value = (salary_value || "").toString().replace(/\./g, "");

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/user-staff"}`,
        {
          name,
          phone,
          email,
          address,
          permission_name,
          date_get_salary,
          salary_by,
          salary_value: _salary_value,
          hour_working_on_day,
          status_working,
          date_join: getDateWithFormat(date_join),
          working_hours: GetWorkingHours(working_hours),
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["user-staff-create"],
        });

        this.dataListRender();
        this.dataStaffAnalyticsRender();
        // this.toggle('add');
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerAddLog = async (logsToSubmit) => {
    if (!isU(ROLE_ALIAS)) return false;

    // New format: logsToSubmit = [{ staffId, logType, value }, ...]
    if (!logsToSubmit || logsToSubmit.length === 0) {
      NotificatioErrController("Vui lòng nhập ít nhất một giá trị");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    let successCount = 0;
    let errorCount = 0;

    // Group logs by staffId and logType for batch processing
    for (const log of logsToSubmit) {
      const logs_form = {
        users_staff_id: [log.staffId],
        [log.logType]: log.value.toString(),
      };

      try {
        await axios.post(`${END_POINT + "/user-staff/log"}`, logs_form, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        });
        successCount++;
      } catch (err) {
        errorCount++;
        console.error("Error adding log:", err);
      }
    }

    if (successCount > 0) {
      NotificatioSucController(`Đã thêm ${successCount} bản ghi thành công`);

      this.socket.emit("create logs", {
        user_id: localStorage.getItem("user_id"),
        message: LogsHelper["user-staff-create-log"],
      });

      this.dataListRender();
      this.dataStaffAnalyticsRender();
      this.toggle("log");
    }

    if (errorCount > 0) {
      NotificatioErrController(`Có ${errorCount} bản ghi lỗi`);
    }
  };

  onHandlerSaveWelfare = async (welfareValues) => {
    if (!isU(ROLE_ALIAS)) return false;

    const { id } = this.state.form;
    if (!id) {
      NotificatioErrController("Không tìm thấy thông tin nhân viên");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");

    // Parse values (remove comma separators)
    const parseValue = (val) => {
      if (!val) return 0;
      return parseInt(String(val).replace(/[,.]/g, ""), 10) || 0;
    };

    const welfareData = {
      user_staff_id: id,
      commission: parseValue(welfareValues.current_commission),
      bonus: parseValue(welfareValues.current_bonus),
      overtime: parseValue(welfareValues.current_overtime),
      fined: parseValue(welfareValues.current_fined),
      advence: parseValue(welfareValues.current_advence),
      dayoff: parseValue(welfareValues.current_dayoff),
    };

    try {
      await axios.post(`${END_POINT}/user-staff/welfare`, welfareData, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      NotificatioSucController("Đã lưu phúc lợi thành công");

      this.socket.emit("create logs", {
        user_id: localStorage.getItem("user_id"),
        message: LogsHelper["user-staff-update"],
      });

      // Refresh data
      this.dataListRender();
      this.dataStaffAnalyticsRender();
      this.dataUserStaffRender(id);
    } catch (err) {
      console.error("Error saving welfare:", err);
      NotificatioErrController(
        err.response?.data?.responseText || "Lỗi lưu phúc lợi"
      );
    }
  };

  /** Axios func helper */

  /** State func helper */
  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;
    if (name === "log" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "add" ? false : prev.show.update,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form: name === "add" ? DEFAULT_FORM : prev.form,
    }));
  };

  onChangeForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: value,
        },
      }));
    } else {
      let { value } = e;
      if (_name === "date_join") {
        value = e;
      } else if (_name === "logs_users_staff") {
        value = e;
      }

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: value,
        },
      }));
    }
  };

  onChangeDynamicForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [name]: value,
          },
        },
      }));
    } else {
      let value = e.value ? e.value : e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [_name]: value,
          },
        },
      }));
    }
  };

  onChangeWorkingHours = (timeOrArray, _name, hash) => {
    // Kiểm tra nếu là array từ ShiftSelect component
    if (Array.isArray(timeOrArray)) {
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          working_hours: timeOrArray,
        },
      }));
      return;
    }

    // Logic cũ cho WorkingHours component
    let find_time = this.state.form.working_hours.find(
      (time) => time.hash === hash
    );

    if (find_time) {
      if (_name === "working_hours_from") {
        find_time.start = timeOrArray.format("HH:mm");
      }
      if (_name === "working_hours_to") {
        find_time.end = timeOrArray.format("HH:mm");
      }
    }

    this.setState((prev) => ({
      ...prev,
      form: {
        ...prev.form,
        working_hours: this.state.form.working_hours,
      },
    }));
  };

  onAddWorkingHours = () => {
    const currentShifts = this.state.form.working_hours;
    let startTime = "08:00";
    let endTime = "12:00";

    // Nếu đã có ca trước, tính thời gian ca mới dựa trên ca cuối
    if (currentShifts && currentShifts.length > 0) {
      const lastShift = currentShifts[currentShifts.length - 1];
      const lastEndTime = lastShift.end;

      // Parse giờ kết thúc của ca trước
      const [lastHour, lastMinute] = lastEndTime.split(":").map(Number);

      // Ca mới bắt đầu từ giờ kết thúc ca trước
      startTime = lastEndTime;

      // Ca mới kết thúc sau 4 tiếng
      let newEndHour = lastHour + 4;
      // Nếu vượt quá 24h thì quay lại
      if (newEndHour >= 24) {
        newEndHour = newEndHour - 24;
      }
      endTime = `${newEndHour.toString().padStart(2, "0")}:${lastMinute
        .toString()
        .padStart(2, "0")}`;
    }

    let time_more = {
      hash: RandomString(5),
      start: startTime,
      end: endTime,
    };

    const add_more_working_hour = [...currentShifts];
    add_more_working_hour.push(time_more);
    this.setState((prev) => ({
      ...prev,
      form: {
        ...prev.form,
        working_hours: add_more_working_hour,
      },
    }));
  };

  onRemoveWorkingHours = (hash) => {
    const remove_working_hour = this.state.form.working_hours.filter(
      (hour) => hour.hash !== hash
    );
    this.setState((prev) => ({
      ...prev,
      form: {
        ...prev.form,
        working_hours: remove_working_hour,
      },
    }));
  };

  onSubmitForm = (type) => {
    if (type === "update") {
      this.onHandlerUpdate();
    } else if (type === "add") {
      this.onHandlerAdd();
    }
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender()
    );
  };

  onSearchInputChange = (e) => {
    const value = e.target.value;
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          search: value,
          currentPage: value ? prev.page.currentPage : 1,
        },
      }),
      () => {
        if (!value) this.dataListRender();
      }
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.key === "Enter") {
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            currentPage: 1,
          },
        }),
        () => this.dataListRender()
      );
    }
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender()
    );
  };

  onClickedItem = (item, callback, args) => {
    const { id, dynamic_form } = item;

    this.setState(
      (prev) => ({
        ...prev,
        is_loading_data_detail: true,
        selectedStaffId: id,
        show: {
          ...prev.show,
          update: false,
          view: true,
          viewonly: false,
        },
        form: {
          ...prev.form,
          id,
          dynamic_form,
        },
        isDetailModalOpen: this.isMobileStaffView(),
      }),
      () => {
        if (callback && args) callback(args[0], args[1], args[2]);

        this.dataUserStaffRender(id);
      }
    );
  };

  onClickedUpdate = (item) => {
    const { id, dynamic_form } = item;

    this.setState(
      (prev) => ({
        ...prev,
        is_loading_data_detail: true,
        selectedStaffId: id,
        show: {
          ...prev.show,
          viewonly: false,
          update: true,
          view: true,
        },
        form: {
          ...DEFAULT_FORM, // Reset to default first
          id,
          dynamic_form,
        },
        selectedItems: [item.id],
      }),
      () => {
        this.dataUserStaffRender(id);
      }
    );
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require"
    );
    if (window.confirm("Bạn chắc chắn muốn xoá nhân viên này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete()
      );
    }
  };

  onClickedCheckbox = (id, event) => {
    // Toggle multi-select
    let selectedSet = SetItemsSelected(id, this.state.selectedItems);

    this.setState((prev) => ({
      ...prev,
      selectedItems: selectedSet,
    }));
  };

  onToggleAllVisible = () => {
    const visibleIds = this.getFilteredData().map((item) => item.id);
    const allVisibleSelected =
      visibleIds.length &&
      visibleIds.every((id) => this.state.selectedItems.includes(id));

    this.setState((prev) => ({
      ...prev,
      selectedItems: allVisibleSelected
        ? prev.selectedItems.filter((id) => !visibleIds.includes(id))
        : [...new Set(prev.selectedItems.concat(visibleIds))],
    }));
  };

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  filterData = (key, value) => {
    this.setState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [key]: value,
      },
      filter: value ? { column: key, value } : null,
    }));
  };

  clearFilters = () => {
    this.setState({
      filters: {
        position: "",
        status: "",
        shift: "",
      },
    });
  };

  toggleDetailTab = (tab) => {
    if (this.state.detailPanelTab !== tab) {
      this.setState({ detailPanelTab: tab });
    }
  };

  getSelectedStaff = () => {
    const { data_all, selectedStaffId } = this.state;
    return data_all.find((item) => item.id === selectedStaffId) || null;
  };

  getStaffWorkingHours = (item) => {
    if (!item) return [];
    const detail = this.state.staffDetailsById[item.id];
    if (detail && detail.setting) {
      return WorkingHours(detail.setting.working_hours);
    }
    if (this.state.selectedStaffId === item.id) return this.state.form.working_hours;
    if (typeof item.working_hours === "string") return WorkingHours(item.working_hours);
    return item.working_hours || [];
  };

  getFilteredData = () => {
    const { data, filters, page } = this.state;
    const search = `${page.search || ""}`.trim().toLowerCase();

    return data.filter((item) => {
      const workingHours = this.getStaffWorkingHours(item);
      const shiftName = getShiftName(workingHours);
      const matchesSearch =
        !search ||
        `${item.name || ""}`.toLowerCase().includes(search) ||
        `${item.phone || ""}`.toLowerCase().includes(search) ||
        `${item.email || ""}`.toLowerCase().includes(search);
      const matchesPosition =
        !filters.position || item.permission_name === filters.position;
      const matchesStatus =
        !filters.status || item.status_working === filters.status;
      const matchesShift = !filters.shift || shiftName === filters.shift;

      return matchesSearch && matchesPosition && matchesStatus && matchesShift;
    });
  };

  getPositionOptions = () => {
    const positions = this.state.data_all
      .map((item) => item.permission_name)
      .filter(Boolean);
    return [...new Set(positions)];
  };

  getKpiData = () => {
    const { analyticsSummary, analyticsAllTimeSummary, data_all, totalStaff } =
      this.state;
    const currentPageWorking = data_all.filter(
      (item) => item.status_working === "on"
    ).length;
    const currentPageOff = data_all.filter(
      (item) => item.status_working === "off"
    ).length;
    const total = totalStaff || analyticsAllTimeSummary.total_staff_count || 0;
    const active =
      analyticsAllTimeSummary.active_staff_count || currentPageWorking || 0;
    const off =
      total && total >= active
        ? total - active
        : currentPageOff || 0;

    return [
      {
        icon: "simple-icon-people",
        iconColor: "#0d6efd",
        iconBg: "rgba(13, 110, 253, 0.12)",
        color: "blue",
        label: "user-staff.kpi.total",
        value: total,
        hint: "user-staff.kpi.current",
      },
      {
        icon: "simple-icon-user-following",
        color: "green",
        iconColor: "#198754",
        iconBg: "rgba(25, 135, 84, 0.12)",
        label: "user-staff.kpi.active",
        value: active,
        hint: "user-staff.kpi.current",
      },
      {
        icon: "simple-icon-user-unfollow",
        color: "red",
        iconColor: "#dc3545",
        iconBg: "rgba(220, 53, 69, 0.12)",
        label: "user-staff.kpi.inactive",
        value: off,
        hint: "user-staff.kpi.current",
      },
      {
        icon: "simple-icon-wallet",
        color: "cyan",
        iconColor: "#0284c7",
        iconBg: "rgba(2, 132, 199, 0.12)",
        label: "user-staff.kpi.revenue-today",
        value: getMoney(analyticsSummary.total_sales || 0),
        hint: "user-staff.kpi.today",
      },
    ];
  };

  getMessage = (id, fallback) => {
    const { intl } = this.props;
    if (intl && intl.formatMessage) {
      return intl.formatMessage({ id });
    }
    return fallback || id;
  };

  renderModals = () => {
    const {
      show,
      data_all,
      data_dynamic_form,
      form,
      is_loading_data_detail,
    } = this.state;

    return (
      <>
        <AddUserStaffLog
          title={this.getMessage(
            "user-staff.add-log-title",
            "Thêm thông tin lương nhân viên"
          )}
          isOpen={show.log}
          toggle={() => {
            this.toggle("log");
          }}
          data_all={data_all}
          onSubmit={this.onHandlerAddLog}
        />
        <AddUserStaff
          title={<IntlMessages id="user-staff.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onChangeWorkingHours={this.onChangeWorkingHours}
          onAddWorkingHours={this.onAddWorkingHours}
          onRemoveWorkingHours={this.onRemoveWorkingHours}
          onChangeDynamicForm={this.onChangeDynamicForm}
          onSubmit={this.onHandlerAdd}
        />
        <UpdateUserStaff
          title={<IntlMessages id="user-staff.title" />}
          onSubmit={this.onHandlerUpdate}
          isOpen={show.update}
          isLoading={is_loading_data_detail}
          toggle={() => {
            this.toggle("update");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onChangeWorkingHours={this.onChangeWorkingHours}
          onAddWorkingHours={this.onAddWorkingHours}
          onRemoveWorkingHours={this.onRemoveWorkingHours}
          onChangeDynamicForm={this.onChangeDynamicForm}
          salaryDownloadData={form.lst_6_month}
          onClickDownloadSalary={this.onDownloadPdfUserStaffRender}
          onSaveWelfare={this.onHandlerSaveWelfare}
        />
      </>
    );
  };

  renderStaffAvatar = (item, size = "md") => (
    <div className={`staff-redesign__avatar staff-redesign__avatar--${size}`}>
      {getInitials(item && item.name)}
    </div>
  );

  renderStatusBadge = (status) => {
    const isWorking = status === "on";
    return (
      <span
        className={classnames("staff-redesign__status", {
          "staff-redesign__status--on": isWorking,
          "staff-redesign__status--off": !isWorking,
        })}
      >
        <span />
        {GetStatusWorking(status).label}
      </span>
    );
  };

  renderKpiCards = () => (
    <Row className="staff-redesign__kpis">
      {this.getKpiData().map((item) => (
        <Col key={item.label} xs="6" lg="6" xl="3">
          {/* <div className="staff-redesign__kpi-card">
            <div className={`staff-redesign__kpi-icon staff-redesign__kpi-icon--${item.color}`}>
              <i className={item.icon} />
            </div>
            <div>
              <div className="staff-redesign__kpi-label">
                <IntlMessages id={item.label} />
              </div>
              <div className="staff-redesign__kpi-value">{item.value}</div>
              <div className="staff-redesign__kpi-hint">
                <IntlMessages id={item.hint} />
              </div>
            </div>
          </div> */}
          <Card>
            <CardBody className="py-3 d-flex align-items-center">
              <div
                className="d-flex align-items-center justify-content-center mr-2"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  backgroundColor: item.iconBg,
                }}
              >
                <i
                  className={item.icon}
                  style={{ color: item.iconColor, fontSize: "1.15rem" }}
                />
              </div>
              <div>
                <div className="text-muted text-small mb-2"><IntlMessages id={item.label} /></div>
                <div className="h6 mb-0">{item.value}</div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );

  renderToolbar = () => {
    const { page, selectedItems, hide_button_add, filters } = this.state;
    const hasSelected = selectedItems && selectedItems.length > 0;
    const positionOptions = this.getPositionOptions();

    return (
      <div className="staff-redesign__toolbar">
        {/* <div className="staff-redesign__search">
          <i className="simple-icon-magnifier" />
          <Input
            value={page.search}
            onChange={this.onSearchInputChange}
            onKeyDown={this.onSearchKey}
            placeholder={this.getMessage(
              "user-staff.search-placeholder",
              "Tìm nhân viên..."
            )}
          />
        </div> */}
        <div className="staff-redesign__toolbar-filters">
          <Input
            type="select"
            value={filters.position}
            onChange={(e) => this.filterData("position", e.target.value)}
          >
            <option value="">
              {this.getMessage("user-staff.filter.position-all", "Vị trí: Tất cả")}
            </option>
            {positionOptions.map((position) => (
              <option key={position} value={position}>
                {position}
              </option>
            ))}
          </Input>
          <Input
            type="select"
            value={filters.status}
            onChange={(e) => this.filterData("status", e.target.value)}
          >
            <option value="">
              {this.getMessage("user-staff.filter.status-all", "Trạng thái: Tất cả")}
            </option>
            <option value="on">{GetStatusWorking("on").label}</option>
            <option value="off">{GetStatusWorking("off").label}</option>
          </Input>
          <Input
            type="select"
            value={filters.shift}
            onChange={(e) => this.filterData("shift", e.target.value)}
          >
            <option value="">
              {this.getMessage("user-staff.filter.shift-all", "Ca làm việc: Tất cả")}
            </option>
            <option value="Ca sáng">Ca sáng</option>
            <option value="Ca chiều">Ca chiều</option>
            <option value="Ca tối">Ca tối</option>
            <option value="Hành chính">Hành chính</option>
          </Input>
          {/* <Button color="outline-primary" onClick={this.clearFilters}>
            <i className="simple-icon-equalizer mr-1" />
            <IntlMessages id="user-staff.filter.clear" />
          </Button> */}
        </div>
        <div className="staff-redesign__toolbar-actions">
          <Button
            color="outline-primary"
            disabled={!isU(ROLE_ALIAS)}
            onClick={() => this.toggle("log")}
          >
            <i className="simple-icon-plus mr-1" />
            <IntlMessages id="pages.add-new-log" />
          </Button>
          <Button
            color="primary"
            disabled={!isC(ROLE_ALIAS)}
            onClick={() => {
              if (hide_button_add) {
                NotificatioErrController(
                  "Gói cước hiện tại của bạn đã đạt giới hạn nhân viên. Vui lòng nâng cấp để thêm mới!"
                );
              } else {
                this.toggle("add");
              }
            }}
          >
            <i className="simple-icon-user-follow mr-1" />
            <IntlMessages id="pages.add-new" />
          </Button>
          {hasSelected ? (
            <Button
              color="danger"
              disabled={!isD(ROLE_ALIAS)}
              onClick={() => {
                if (window.confirm("Bạn chắc chắn muốn xóa các nhân viên đã chọn?")) {
                  this.onHandlerDelete();
                }
              }}
            >
              <i className="simple-icon-trash mr-1" />
              <IntlMessages id="user-staff.action.delete" /> ({selectedItems.length})
            </Button>
          ) : null}
        </div>
      </div>
    );
  };

  renderStaffTable = (displayData) => {
    const { selectedItems, selectedStaffId, analyticsByStaffId } = this.state;
    const allVisibleSelected =
      displayData.length &&
      displayData.every((item) => selectedItems.includes(item.id));

    return (
      <div className="staff-redesign__table-wrap d-none d-lg-block">
        <table className="staff-redesign__table">
          <thead>
            <tr>
              <th>
                <CustomInput
                  type="checkbox"
                  id="staff-redesign-check-all"
                  label=""
                  checked={Boolean(allVisibleSelected)}
                  onChange={this.onToggleAllVisible}
                />
              </th>
              <th><IntlMessages id="user-staff.table.employee" /></th>
              <th><IntlMessages id="user-staff.table.position" /></th>
              <th><IntlMessages id="user-staff.table.shift" /></th>
              <th><IntlMessages id="user-staff.table.phone" /></th>
              <th><IntlMessages id="user-staff.table.revenue-today" /></th>
              <th><IntlMessages id="user-staff.table.bills" /></th>
              <th><IntlMessages id="user-staff.table.status" /></th>
              <th><IntlMessages id="user-staff.table.action" /></th>
            </tr>
          </thead>
          <tbody>
            {displayData.length ? (
              displayData.map((item) => {
                const analytics = findAnalytics(analyticsByStaffId, item.id);
                const workingHours = this.getStaffWorkingHours(item);
                const shiftName = getShiftName(workingHours);

                return (
                  <tr
                    key={item.id}
                    className={classnames({
                      "is-selected": selectedStaffId === item.id,
                    })}
                    onClick={() => this.onClickedItem(item)}
                  >
                    <td onClick={(e) => e.stopPropagation()}>
                      <CustomInput
                        type="checkbox"
                        id={`staff-redesign-check-${item.id}`}
                        label=""
                        checked={selectedItems.includes(item.id)}
                        onChange={(e) => this.onClickedCheckbox(item.id, e)}
                      />
                    </td>
                    <td>
                      <div className="staff-redesign__employee">
                        {this.renderStaffAvatar(item, "sm")}
                        <div>
                          <div className="staff-redesign__employee-name">
                            {item.name || "--"}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className={classnames("staff-redesign__badge", getPositionClass(item.permission_name))}>
                        {item.permission_name || "--"}
                      </span>
                    </td>
                    <td>
                      <div className="staff-redesign__shift">
                        <strong>{shiftName}</strong>
                        <span>{formatWorkingHours(workingHours)}</span>
                      </div>
                    </td>
                    <td>{item.phone || "--"}</td>
                    <td className="staff-redesign__money">
                      {getMoney(analytics.total_sales || 0)}
                    </td>
                    <td>{analytics.bill_count || 0}</td>
                    <td>{this.renderStatusBadge(item.status_working)}</td>
                    <td onClick={(e) => e.stopPropagation()}>
                      <UncontrolledDropdown>
                        <DropdownToggle color="" className="staff-redesign__icon-btn">
                          <i className="simple-icon-options" />
                        </DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem
                            disabled={!isU(ROLE_ALIAS)}
                            onClick={() => this.onClickedUpdate(item)}
                          >
                            <IntlMessages id="user-staff.action.edit" />
                          </DropdownItem>
                          <DropdownItem
                            disabled={!isU(ROLE_ALIAS)}
                            onClick={() => this.toggle("log")}
                          >
                            <IntlMessages id="pages.add-new-log" />
                          </DropdownItem>
                          <DropdownItem divider />
                          <DropdownItem
                            className="text-danger"
                            disabled={!isD(ROLE_ALIAS)}
                            onClick={() => this.onClickedDelete(item)}
                          >
                            <IntlMessages id="user-staff.action.delete" />
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" className="text-center text-muted py-5">
                  <IntlMessages id="user-staff.empty" />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  renderMobileStaffCards = (displayData) => {
    const { selectedItems, selectedStaffId, analyticsByStaffId } = this.state;

    return (
      <div className="staff-redesign__mobile-list d-lg-none">
        {displayData.length ? (
          displayData.map((item) => {
            const analytics = findAnalytics(analyticsByStaffId, item.id);
            const workingHours = this.getStaffWorkingHours(item);

            return (
              <div
                key={item.id}
                className={classnames("staff-redesign__mobile-card", {
                  "is-selected": selectedStaffId === item.id,
                })}
                onClick={() => this.onClickedItem(item)}
              >
                <div className="staff-redesign__mobile-head">
                  <div className="staff-redesign__employee">
                    {this.renderStaffAvatar(item, "sm")}
                    <div>
                      <div className="staff-redesign__employee-name">
                        {item.name || "--"}
                      </div>
                    </div>
                  </div>
                  <div onClick={(e) => e.stopPropagation()}>
                    <CustomInput
                      type="checkbox"
                      id={`staff-redesign-mobile-check-${item.id}`}
                      label=""
                      checked={selectedItems.includes(item.id)}
                      onChange={(e) => this.onClickedCheckbox(item.id, e)}
                    />
                  </div>
                </div>
                <div className="staff-redesign__mobile-meta">
                  <span>{item.permission_name || "--"}</span>
                  <span>{item.phone || "--"}</span>
                  <span>{getShiftName(workingHours)}</span>
                  <span className="staff-redesign__money">
                    {getMoney(analytics.total_sales || 0)}
                  </span>
                </div>
                <div className="staff-redesign__mobile-foot">
                  {this.renderStatusBadge(item.status_working)}
                  <Button
                    color="link"
                    disabled={!isU(ROLE_ALIAS)}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.onClickedUpdate(item);
                    }}
                  >
                    <IntlMessages id="user-staff.action.edit" />
                  </Button>
                </div>
              </div>
            );
          })
        ) : (
          <Card className="mb-3">
            <CardBody className="text-center text-muted">
              <IntlMessages id="user-staff.empty" />
            </CardBody>
          </Card>
        )}
      </div>
    );
  };

  renderDetailField = (labelId, value) => (
    <div className="staff-redesign__detail-row">
      <span><IntlMessages id={labelId} /></span>
      <strong>{value || "--"}</strong>
    </div>
  );

  renderOverviewTile = (labelId, value, icon, color) => (
    <div className="staff-redesign__overview-tile">
      <div>
        <span><IntlMessages id={labelId} /></span>
        <strong>{value}</strong>
      </div>
      <div className={`staff-redesign__overview-icon staff-redesign__overview-icon--${color}`}>
        <i className={icon} />
      </div>
    </div>
  );

  renderDetailPanel = () => {
    const {
      form,
      detailPanelTab,
      is_loading_data_detail,
      analyticsByStaffId,
      analyticsAllTimeByStaffId,
    } = this.state;
    const selectedStaff = this.getSelectedStaff();

    if (!selectedStaff) {
      return (
        <aside className="staff-redesign__detail-panel">
          <div className="staff-redesign__empty-panel">
            <i className="simple-icon-user" />
            <IntlMessages id="user-staff.detail.empty" />
          </div>
        </aside>
      );
    }

    const values = {
      ...selectedStaff,
      ...form,
    };
    const currentAnalytics = findAnalytics(analyticsByStaffId, selectedStaff.id);
    const allTimeAnalytics = findAnalytics(analyticsAllTimeByStaffId, selectedStaff.id);
    const phone = values.phone || "";
    const email = values.email || "";

    return (
      <aside className="staff-redesign__detail-panel">
        {is_loading_data_detail ? (
          <div className="loading" />
        ) : (
          <>
            <div className="staff-redesign__detail-close d-lg-none">
              <Button
                color="link"
                onClick={this.closeDetailModal}
              >
                <i className="simple-icon-close" />
              </Button>
            </div>
            <div className="staff-redesign__profile">
              {this.renderStaffAvatar(values, "lg")}
              <div>
                <h2>{values.name || "--"}</h2>
                <span className={classnames("staff-redesign__badge", getPositionClass(values.permission_name))}>
                  {values.permission_name || "--"}
                </span>
                <p><i className="simple-icon-phone mr-1" />{phone || "--"}</p>
                <p><i className="simple-icon-envelope mr-1" />{email || "--"}</p>
              </div>
            </div>
            <div className="staff-redesign__profile-actions">
              <a
                href={phone ? `tel:${phone}` : undefined}
                className={classnames("staff-redesign__round-action", {
                  disabled: !phone,
                })}
                onClick={(event) => {
                  if (!phone) event.preventDefault();
                }}
              >
                <i className="simple-icon-phone" />
                <span><IntlMessages id="user-staff.action.call" /></span>
              </a>
              <a
                href={phone ? `sms:${phone}` : undefined}
                className={classnames("staff-redesign__round-action", {
                  disabled: !phone,
                })}
                onClick={(event) => {
                  if (!phone) event.preventDefault();
                }}
              >
                <i className="simple-icon-bubbles" />
                <span><IntlMessages id="user-staff.action.message" /></span>
              </a>
              <a
                href={email ? `mailto:${email}` : undefined}
                className={classnames("staff-redesign__round-action", {
                  disabled: !email,
                })}
                onClick={(event) => {
                  if (!email) event.preventDefault();
                }}
              >
                <i className="simple-icon-envelope" />
                <span>Email</span>
              </a>
            </div>
            <div className="staff-redesign__detail-tabs-wrap">
              <Nav
                tabs
                innerRef={this.detailTabsRef}
                className="staff-redesign__detail-tabs"
                onMouseDown={this.onDetailTabsMouseDown}
                onMouseMove={this.onDetailTabsMouseMove}
                onMouseUp={this.onDetailTabsMouseUp}
                onMouseLeave={this.onDetailTabsMouseUp}
              >
                {DETAIL_TABS.map((tab) => (
                  <NavItem key={tab.id}>
                    <NavLink
                      to="#"
                      location={{}}
                      onClick={(event) => this.onDetailTabClick(event, tab.id)}
                      className={classnames("nav-link", {
                        active: detailPanelTab === tab.id,
                      })}
                    >
                      <IntlMessages id={tab.label} />
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </div>
            <TabContent activeTab={detailPanelTab} className="staff-redesign__detail-content">
              <TabPane tabId="info">
                <h3><IntlMessages id="user-staff.detail.basic" /></h3>
                {this.renderDetailField(
                  "user-staff.detail.birthday",
                  values.birthday ? moment(values.birthday).format("DD/MM/YYYY") : "--"
                )}
                {this.renderDetailField("user-staff.permission_name", values.permission_name)}
                {this.renderDetailField(
                  "user-staff.date_join",
                  values.date_join ? moment(values.date_join).format("DD/MM/YYYY") : "--"
                )}
                {this.renderDetailField("user-staff.status_working", GetStatusWorking(values.status_working).label)}
                {this.renderDetailField("address", values.address)}
                <div className="staff-redesign__overview">
                  {this.renderOverviewTile(
                    "user-staff.today.revenue",
                    getMoney(allTimeAnalytics.total_sales || 0),
                    "simple-icon-wallet",
                    "green"
                  )}
                  {this.renderOverviewTile(
                    "user-staff.today.bills",
                    allTimeAnalytics.bill_count || 0,
                    "simple-icon-doc",
                    "blue"
                  )}
                  {this.renderOverviewTile(
                    "user-staff.today.products",
                    allTimeAnalytics.product_count || 0,
                    "simple-icon-basket",
                    "orange"
                  )}
                  {this.renderOverviewTile(
                    "analytics.staff.commission",
                    getMoney(allTimeAnalytics.commission || 0),
                    "simple-icon-badge",
                    "purple"
                  )}
                </div>
              </TabPane>
              <TabPane tabId="schedule">
                <h3><IntlMessages id="user-staff.detail.schedule" /></h3>
                {this.renderDetailField("user-staff.table.shift", getShiftName(values.working_hours))}
                {this.renderDetailField("user-staff.working_hours", formatWorkingHours(values.working_hours))}
                {this.renderDetailField("user-staff.hour_working_on_day", values.hour_working_on_day)}
                {this.renderDetailField("user-staff.date_get_salary", values.date_get_salary)}
              </TabPane>
              <TabPane tabId="performance">
                <h3><IntlMessages id="user-staff.detail.performance" /></h3>
                <div className="staff-redesign__overview staff-redesign__overview--performance">
                  {this.renderOverviewTile("analytics.staff.sales", getMoney(currentAnalytics.total_sales || 0), "simple-icon-wallet", "green")}
                  {this.renderOverviewTile("analytics.staff.bill_count", currentAnalytics.bill_count || 0, "simple-icon-doc", "blue")}
                  {this.renderOverviewTile("analytics.staff.product_count", currentAnalytics.product_count || 0, "simple-icon-basket", "orange")}
                  {this.renderOverviewTile("analytics.staff.commission", getMoney(currentAnalytics.commission || 0), "simple-icon-badge", "purple")}
                </div>
              </TabPane>
              <TabPane tabId="salary">
                <h3><IntlMessages id="user-staff.detail.salary" /></h3>
                {this.renderDetailField("user-staff.salary_by", GetSalaryBy(values.salary_by).label)}
                {this.renderDetailField("user-staff.salary_value", getMoney(values.salary_value || 0))}
                {this.renderDetailField("user-staff.current_day_working", values.current_day_working)}
                {this.renderDetailField("user-staff.current_salary", getMoney(values.current_salary || 0))}
                {this.renderDetailField("user-staff.current_commission", getMoney(values.current_commission || 0))}
                {this.renderDetailField("user-staff.current_bonus", getMoney(values.current_bonus || 0))}
                {this.renderDetailField("user-staff.current_overtime", getMoney(values.current_overtime || 0))}
                {this.renderDetailField("user-staff.current_advence", getMoney(values.current_advence || 0))}
                {this.renderDetailField("user-staff.current_fined", getMoney(values.current_fined || 0))}
                {this.renderDetailField("user-staff.total_salary", getMoney(values.total_salary || 0))}
              </TabPane>
              <TabPane tabId="permission">
                <h3><IntlMessages id="user-staff.detail.permission" /></h3>
                {this.renderDetailField("user-staff.permission_name", values.permission_name)}
                {this.renderDetailField("user-staff.status_working", GetStatusWorking(values.status_working).label)}
                {this.renderDetailField("user-staff.detail.dynamic-fields", Object.keys(values.dynamic_form || {}).length)}
              </TabPane>
            </TabContent>
          </>
        )}
      </aside>
    );
  };

  render() {
    const { match } = this.props;
    const { page, data, is_loading_data, isDetailModalOpen } = this.state;
    const displayData = this.getFilteredData();

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );

    return is_loading_data ? (
      <div className="loading" />
    ) : (
      <div className="staff-redesign disable-text-selection">
        {this.renderModals()}
        {/* <div className="staff-redesign__heading">
          <div>
            <h1><IntlMessages id="analytics.user-staff" /></h1>
            <Breadcrumb match={match} />
          </div>
        </div> */}
        <div className="staff-redesign__main">
          <section className="staff-redesign__list-panel">
            {this.renderKpiCards()}
            <Card className="staff-redesign__section-card staff-redesign__section-card--staff-list">
              <CardBody>
                {this.renderToolbar()}
                {data.length === 0 ? (
                  <div className="staff-redesign__empty-list">
                    <IntlMessages id="user-staff.empty" />
                  </div>
                ) : (
                  <>
                    {this.renderStaffTable(displayData)}
                    {this.renderMobileStaffCards(displayData)}
                    <div className="staff-redesign__pagination">
                      <div>
                        {page.totalItem ? (
                          <span>
                            {page.selectedPageSize * (page.currentPage - 1) + 1}-
                            {Math.min(page.selectedPageSize * page.currentPage, page.totalItem)}{" "}
                            / {page.totalItem}
                          </span>
                        ) : null}
                        <Input
                          type="select"
                          value={page.selectedPageSize}
                          onChange={(e) => this.onChangePageSize(parseInt(e.target.value, 10))}
                        >
                          {page.pageSizes.map((size) => (
                            <option key={size} value={size}>
                              {size} / trang
                            </option>
                          ))}
                        </Input>
                      </div>
                      <Pagination
                        currentPage={page.currentPage}
                        totalPage={page.totalPage}
                        onChangePage={(i) => this.onChangePage(i)}
                        firstIsActive={false}
                        lastIsActive={false}
                      />
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </section>
          <div className="staff-redesign__detail-card">
            {this.renderDetailPanel()}
          </div>
        </div>
        <Modal
          isOpen={isDetailModalOpen}
          toggle={this.closeDetailModal}
          wrapClassName="modal-right staff-redesign__detail-modal-wrap"
          className="staff-redesign__detail-modal"
        >
          <ModalBody className="p-0">
            {this.renderDetailPanel()}
          </ModalBody>
        </Modal>
        <FooterPage>
          <FooterUserStaff />
        </FooterPage>
      </div>
    );
  }
}

const mapStateToProps = ({ searchInput }) => {
  const { keyword: searchKeyword } = searchInput;
  return { searchKeyword };
};

export default connect(mapStateToProps, {
  setSearchContext,
})(injectIntl(ContentComponent));
